<template>
  <div class="content">
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
        <el-tab-pane :label="$t('app.rechargePassword.setPassword')" name="first">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
            <el-form-item :label="$t('app.rechargePassword.password')" prop="newPassword">
              <el-input v-model="ruleForm.newPassword" type="password" autocomplete="new-password" :placeholder="$t('app.rechargePassword.enterPassword')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.rechargePassword.confirmPassword')" prop="checkPass">
              <el-input v-model="ruleForm.checkPass" type="password" :placeholder="$t('app.rechargePassword.enterConfirmPassword')"></el-input>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit('ruleForm')">{{ $t('app.common.submit') }}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('app.rechargePassword.modifyPassword')" name="second">
          <el-form :model="modifyruleForm" :rules="modifyrules" ref="modifyruleForm" label-width="160px" class="demo-ruleForm">
            <el-form-item :label="$t('app.rechargePassword.oldPassword')" prop="oldPassword">
              <el-input v-model="modifyruleForm.oldPassword" type="password" autocomplete="new-password" :placeholder="$t('app.rechargePassword.enterOldPassword')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.rechargePassword.newPassword')" prop="newPassword">
              <el-input v-model="modifyruleForm.newPassword" type="password" autocomplete="new-password" :placeholder="$t('app.rechargePassword.enterNewPassword')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.rechargePassword.confirmPassword')" prop="checkPass">
              <el-input v-model="modifyruleForm.checkPass" type="password" autocomplete="new-password" :placeholder="$t('app.rechargePassword.enterConfirmPassword')"></el-input>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="modifyonSubmit('modifyruleForm')">{{ $t('app.common.submit') }}</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>
<script>
import { setPayPassword } from "@/api/api.js"; //设置套餐充值密码
import { changePayPassword } from "@/api/api.js"; //重置套餐充值密码
export default {
  name:'rechargePassword',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('app.rechargePassword.validate.enterPassword')));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('app.rechargePassword.validate.enterConfirmPassword')));
        } else if (value !== this.ruleForm.newPassword) {
          callback(new Error(this.$t('app.rechargePassword.validate.passwordMismatch')));
        } else {
          callback();
        }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('app.rechargePassword.validate.enterNewPassword')));
      } else {
        if (this.modifyruleForm.checkPass !== '') {
          this.$refs.modifyruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('app.rechargePassword.validate.enterConfirmPassword')));
        } else if (value !== this.modifyruleForm.newPassword) {
          callback(new Error(this.$t('app.rechargePassword.validate.passwordMismatch')));
        } else {
          callback();
        }
    };
    return {
      activeName: 'first',
      ruleForm:{
        newPassword: '',
        checkPass: '',
      },
      rules:{
        newPassword: [
          { required: true,validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true,validator: validatePass2, trigger: 'blur' }
        ],
      },

      modifyruleForm:{
        oldPassword:'',
        newPassword:'',
        checkPass: ''
      },
      modifyrules:{
        oldPassword:[
          { required: true, message: this.$t('app.rechargePassword.validate.enterOldPassword'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true,validator: validatePass3, trigger: 'blur' }
        ],
        checkPass: [
          { required: true,validator: validatePass4, trigger: 'blur' }
        ],
      }
    };
  },
  computed: {},
  methods: {
    handleClick(tab, event) {
      if(tab.label == "修改充值密码"){
        this.reset();
      }else{
        this.resetPassword();
      }
    },
    // 设置充值密码的提交
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if(valid){
          let params = {
            newPassword:this.ruleForm.newPassword
          }
          setPayPassword(params).then(res=>{
              this.$notify({
                title: this.$t('app.common.success'),
                message:  this.$t('app.rechargePassword.success.set'),
                type: 'success'
              });
              this.reset();
          })
        }
      })
    },
    reset(){
      this.resetForm("ruleForm");
    },
    resetPassword(){
      this.resetForm("modifyruleForm");
    },
    // 设置修改密码的提交
    modifyonSubmit(formName){
      this.$refs[formName].validate((valid) => {
        let params = {
          newPassword:this.modifyruleForm.newPassword,
          oldPassword:this.modifyruleForm.oldPassword
        }
        if(valid){
          changePayPassword(params).then(res=>{
              this.$notify({
                title: this.$t('app.common.success'),
                message: this.$t('app.rechargePassword.success.modify'),
                type: 'success'
              });
              this.resetPassword();
          })
        }
      })
    }
  },
  mounted() {

  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
  .demo-ruleForm{
    width: 400px;
    margin-top: 25px;
  }
  /deep/ .el-form-item{
    margin-bottom:30px !important;
  }
</style>


